import { haversineDistance } from '@/lib/calculateDistance';
import { GeneralRawDealerType } from '@/lib/schema/dealer/types';
import { validateUSZipCode } from '@/lib/validators';
import { FilterState } from '@/types/filters';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { useQuery } from '@tanstack/react-query';

interface ProductListingLinkFooterProps {
  dealerInfo: GeneralRawDealerType;
  isColumnLayout?: boolean;
  filters?: FilterState;
}

export const ProductListingLinkFooter: React.FC<
  ProductListingLinkFooterProps
> = ({ dealerInfo, filters, isColumnLayout }) => {
  const { data: distance } = useQuery({
    queryKey: ['distance', filters?.fields.postal, dealerInfo.PostalCode],
    queryFn: async () => {
      const response = await fetch(
        `/api/distance?zipCode1=${filters?.fields.postal}&zipCode2=${dealerInfo.PostalCode}`
      );
      if (!response.ok) {
        return null;
      }
      const data = await response.json();
      const { coords1, coords2 } = data;
      const distanceInMiles = haversineDistance(coords1, coords2);

      return distanceInMiles;
    },
    enabled: Boolean(
      filters?.fields.postal && validateUSZipCode(filters?.fields.postal)
    ),
  });

  return (
    <div
      className={`flex w-full items-center ${isColumnLayout ? 'justify-center' : 'justify-start'} gap-xl px-xl py-l`}
    >
      <div
        className={`${
          dealerInfo?.Dealership ? 'flex' : 'w-full'
        } items-center justify-end gap-xs whitespace-nowrap text-microLight text-neutral-800`}
      >
        <MapPinIcon height={16} width={16} />
        {dealerInfo.City}, {dealerInfo.State}{' '}
        {distance ? `(${Math.round(distance)} mi)` : ''}
      </div>
    </div>
  );
};
